export enum EGeneral {
  ALL = 'ALL',
}



export default EGeneral;
